<template>
  <base-nav
    v-model="showMenu"
    type="white"
    :transparent="true"
    menu-classes="justify-content-center"
    class="auth-navbar fixed-top"
  >
    <div slot="brand" class="navbar-wrapper">
      <div class="navbar-minimize d-inline">
        <sidebar-toggle-button/>
      </div>
      <div
        class="navbar-toggle d-inline"
        :class="{ toggled: $sidebar.showSidebar }"
      >
        <button type="button" class="navbar-toggler" @click="toggleSidebar">
          <span class="navbar-toggler-bar bar1"></span>
          <span class="navbar-toggler-bar bar2"></span>
          <span class="navbar-toggler-bar bar3"></span>
        </button>
      </div>
      <a class="navbar-brand" href="">{{ $t("router." + routeTitle) }}</a>
    </div>

    <ul class="navbar-nav" :class="$rtl.isRTL ? 'mr-auto' : 'ml-auto'">
      <theme-settings-nav-bar/>
      <language-settings-nav-bar/>

      <base-dropdown
        tag="li"
        :menu-on-right="!$rtl.isRTL"
        title-tag="a"
        class="nav-item"
        title-classes="nav-link"
        menu-classes="dropdown-navbar"
      >
        <template slot="title">
          <div class="d-none d-lg-block d-xl-block"></div>
          <i class="mdi mdi_icon mdi-24px mdi-cog-outline"></i>
          <!--          <b class="caret d-none d-lg-block d-xl-block"></b>-->
          <!--          <p class="d-lg-none">{{ $t('navbar.menu') }}</p>-->
        </template>
        <li class="nav-link">
          <router-link
            class="nav-item dropdown-item pt-0 pb-0"
            :to="{ path: '/user/profile' }"
          >
            <i class="mdi mdi_icon mdi-24px mdi-account-box-outline"/>
            {{ $t('navbar.profile') }}
          </router-link>
        </li>
        <!--        <li class="nav-link">-->
        <!--          <a href="#" class="nav-item dropdown-item">{{ $t('navbar.settings') }}</a>-->
        <!--        </li>-->
        <div class="dropdown-divider"></div>
        <li class="nav-link">

          <router-link
            class="nav-item dropdown-item pt-0 pb-0"
            :to="{ path: '/logout' }"
          >
            <i class="mdi mdi_icon mdi-24px mdi-logout "/>
            {{ $t('navbar.logout') }}
          </router-link>

          <!-- <a href="/logout" class="nav-item dropdown-item">Log out</a> -->
        </li>
      </base-dropdown>

      <distributor-client-u-i-nav-bar/>
      <account-search-nav-bar/>

      <!--      <base-dropdown-->
      <!--        tag="li"-->
      <!--        :menu-on-right="!$rtl.isRTL"-->
      <!--        title-tag="a"-->
      <!--        title-classes="nav-link"-->
      <!--        class="nav-item"-->
      <!--      >-->
      <!--        <template-->
      <!--          slot="title"-->
      <!--        >-->
      <!--          <div class="notification d-none d-lg-block d-xl-block"></div>-->
      <!--          <i class="tim-icons icon-sound-wave"></i>-->
      <!--          <p class="d-lg-none">New Notifications</p>-->
      <!--        </template>-->
      <!--        <li class="nav-link">-->
      <!--          <a href="#" class="nav-item dropdown-item"-->
      <!--          >Mike John responded to your email</a-->
      <!--          >-->
      <!--        </li>-->
      <!--        <li class="nav-link">-->
      <!--          <a href="#" class="nav-item dropdown-item">You have 5 more tasks</a>-->
      <!--        </li>-->
      <!--        <li class="nav-link">-->
      <!--          <a href="#" class="nav-item dropdown-item"-->
      <!--          >Your friend Michael is in town</a-->
      <!--          >-->
      <!--        </li>-->
      <!--        <li class="nav-link">-->
      <!--          <a href="#" class="nav-item dropdown-item">Another notification</a>-->
      <!--        </li>-->
      <!--        <li class="nav-link">-->
      <!--          <a href="#" class="nav-item dropdown-item">Another one</a>-->
      <!--        </li>-->
      <!--      </base-dropdown>-->
    </ul>

  </base-nav>
</template>
<script>
import {CollapseTransition} from 'vue2-transitions';
import {BaseNav, Modal} from '@/components';
import SidebarToggleButton from './SidebarToggleButton';
import LanguageSettingsNavBar from './LanguageSettingsNavBar';
import ThemeSettingsNavBar from './ThemeSettingsNavBar';
import AccountSearchNavBar from './AccountSearchNavBar';
import DistributorClientUINavBar from './DistributorClientUINavBar';

export default {
  components: {
    SidebarToggleButton,
    LanguageSettingsNavBar,
    ThemeSettingsNavBar,
    CollapseTransition,
    BaseNav,
    Modal,
    AccountSearchNavBar,
    DistributorClientUINavBar
  },
  computed: {
    routeTitle() {
      const {meta} = this.$route;
      return meta.title;
    },
    isRTL() {
      return this.$rtl.isRTL;
    }
  },
  data() {
    return {
      showMenu: false,
    };
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
  }
};
</script>
<style scoped>
.top-navbar {
  top: 0px;
}
</style>
